module.exports = __webpack_public_path__ + "49314d1031928920c4986f15745c6c9c.jpg";